import { render } from "./FooterPage.vue?vue&type=template&id=2d82e1ab&scoped=true"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=2d82e1ab&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d82e1ab"]])

export default __exports__